import { AnimatePresence, motion } from "framer-motion";
import { PRODUCT, formatPrice } from "../../data/catalog";

export const StickyATC = ({ show, color, onAdd }) => (
  <AnimatePresence>
    {show && (
      <motion.div initial={{ y: "100%" }} animate={{ y: 0 }} exit={{ y: "100%" }} transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
        className="fixed inset-x-0 bottom-0 z-40 flex items-center gap-3 border-t border-line bg-ivory/95 px-4 py-3 backdrop-blur-xl lg:hidden" data-testid="pdp-sticky-atc">
        <img src={color.image} alt="" className="h-12 w-12 bg-white object-contain" />
        <div className="min-w-0 flex-1">
          <p className="truncate text-sm text-ink">{PRODUCT.name}</p>
          <p className="text-xs text-graphite">{color.name} · {formatPrice(PRODUCT.price)}</p>
        </div>
        <button onClick={onAdd} className="btn-dark !px-5 !py-3" data-testid="pdp-sticky-add-to-cart">Add to bag</button>
      </motion.div>
    )}
  </AnimatePresence>
);
